<template>
    <console-layout max-width="720" width="100%">
        <console-title>
            <v-layout align-center style="gap:16px">
                <span>이달의 추천 도서</span>
                <v-switch v-model="form.main_bookOfTheMonth.uses" v-bind="{ loading }" class="d-inline-block ma-0 pa-0" dense inset hide-details color="primary" />
            </v-layout>
        </console-title>

        <console-body>
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12">
                    <v-card v-bind="{ loading, disable: !form.main_bookOfTheMonth.uses }">
                        <v-card-text>
                            <v-row class="ma-n2">
                                <v-col class="pa-2" cols="12">
                                    <autocomplete-shop-product v-model="form.main_bookOfTheMonth.product" label="도서검색" v-bind="attrs" return-object :params="{ type: 'main', searchKey: 'name' }" clearable @input="({ _id } = {}) => (form.main_bookOfTheMonth._product = _id || null)" />
                                </v-col>
                                <v-col class="pa-2" cols="12" lg="4">
                                    <v-img :aspect-ratio="2 / 3" :src="form?.main_bookOfTheMonth?.product?.thumb" class="v-sheet--outlined" content-class="d-flex justify-center align-center">
                                        <template v-if="!form?.main_bookOfTheMonth?.product?.thumb">
                                            <v-icon x-large>mdi-image-broken-variant</v-icon>
                                        </template>
                                    </v-img>
                                </v-col>
                                <v-col class="pa-2" cols="12" lg="8">
                                    <v-row class="ma-n2">
                                        <v-col class="pa-2" cols="12">
                                            <v-combobox v-model="form.main_bookOfTheMonth.tags" multiple label="해시태그" v-bind="attrs" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12">
                                            <v-text-field v-model="form.main_bookOfTheMonth.name" label="도서제목" v-bind="attrs" :placeholder="form.main_bookOfTheMonth?.product?.name" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="4">
                                            <v-text-field v-model="form.main_bookOfTheMonth.writer" label="작가명" v-bind="attrs" :placeholder="form.main_bookOfTheMonth?.product?.writer" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="4">
                                            <v-text-field v-model="form.main_bookOfTheMonth.publisher" label="출판사" :placeholder="form.main_bookOfTheMonth?.product?.publisher" v-bind="attrs" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="4">
                                            <v-text-field v-model="form.main_bookOfTheMonth.salePrice" label="금액" type="number" :placeholder="form.main_bookOfTheMonth?.product?.salePrice?.format?.()" v-bind="attrs" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12">
                                            <v-textarea v-model="form.main_bookOfTheMonth.text" label="도서소개" rows="3" v-bind="attrs" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12">
                                            <v-text-field v-model="form.main_bookOfTheMonth.name" label="링크" v-bind="attrs" :placeholder="form.main_bookOfTheMonth?.product ? `/shop/products/${form.main_bookOfTheMonth?.product?._id}` : undefined" clearable />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="pa-2" cols="12" md="6">
                    <v-btn block color="error" v-bind="{ loading }" @click="init">
                        <v-layout justify-center align-center style="gap:8px">
                            <v-icon> mdi-refresh </v-icon>
                            <span> 초기화 </span>
                        </v-layout>
                    </v-btn>
                </v-col>
                <v-col class="pa-2" cols="12" md="6">
                    <v-btn block color="primary" v-bind="{ loading }" @click="save">
                        <v-layout justify-center align-center style="gap:8px">
                            <v-icon> mdi-content-save </v-icon>
                            <span> 저장하기 </span>
                        </v-layout>
                    </v-btn>
                </v-col>
            </v-row>
        </console-body>
    </console-layout>
</template>

<script>
import api from "@/api";

import AutocompleteShopProduct from "@/components/console/dumb/autocompletes/autocomplete-shop-product.vue";

const initForm = (form = {}) => ({
    ...(form || {}),
    main_bookOfTheMonth: {
        ...(form?.main_bookOfTheMonth || {}),

        uses: form?.main_bookOfTheMonth?.uses || false,

        _product: form?.main_bookOfTheMonth?._product || null,

        href: form?.main_bookOfTheMonth?.href || null,
        name: form?.main_bookOfTheMonth?.name || null,
        text: form?.main_bookOfTheMonth?.text || null,
        tags: form?.main_bookOfTheMonth?.tags || null,
        writer: form?.main_bookOfTheMonth?.writer || null,
        publisher: form?.main_bookOfTheMonth?.publisher || null,
        salePrice: form?.main_bookOfTheMonth?.salePrice || null,
    },
});

const attrs = {
    dense: true,
    outlined: true,
    hideDetails: true,
    persistentPlaceholder: true,
    class: "ma-0 pa-0",
};

export default {
    components: {
        AutocompleteShopProduct,
    },
    data: () => ({
        form: initForm(),
        loading: false,

        attrs,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { setting } = await api.console.common.setting.get();
                this.form = initForm(setting);
            } finally {
                this.loading = false;
            }
        },
        async save() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { ...main_bookOfTheMonth } = this.form.main_bookOfTheMonth;
                let { setting } = await api.console.common.setting.put({
                    main_bookOfTheMonth,
                });
                this.form = initForm(setting);
                alert("저장되었습니다");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
